import React from 'react';

interface TagOneIconProps {
  className?: string;
  /** 1.5 in the left nav (unchanged); 2 beside the library's 2-stroke icons in a row menu. */
  strokeWidth?: number;
}

const TagOneIcon: React.FC<TagOneIconProps> = ({ className, strokeWidth = 1.5 }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M21.0846 14.6226L14.6315 21.0756C14.2939 21.4136 13.8358 21.6035 13.3581 21.6035C12.8803 21.6035 12.4222 21.4136 12.0845 21.0756L4 13V4H13L21.0846 12.0845C21.7825 12.7866 21.7825 13.9205 21.0846 14.6226Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M9.25 10.5C9.94035 10.5 10.5 9.94035 10.5 9.25C10.5 8.55965 9.94035 8 9.25 8C8.55965 8 8 8.55965 8 9.25C8 9.94035 8.55965 10.5 9.25 10.5Z" fill="currentColor"/>
  </svg>
);

export default TagOneIcon;
